export const API_URL = "https://api.e-cube.it/";
export const PUSHCLIENT_URL = "https://api.e-cube.it/:444/";
export const WSS_URL = "wss://api.e-cube.it/:444";
